import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_STOCKMARKETS_SUCCESS = 'GET_STOCKMARKETS_SUCCESS';
export const GET_STOCKMARKETS_FAILURE = 'GET_STOCKMARKETS_FAILURE';

function receive(stockMarkets) {
  return {
    type: GET_STOCKMARKETS_SUCCESS,
    stockMarkets
  };
}

function reject() {
  return {
    type: GET_STOCKMARKETS_FAILURE
  };
}

export function getStockMarkets() {
  return (dispatch) => {
    const promise = () => ApiService
      .getStockMarkets()
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        if (!error.response) {
          ApiService.addQueuedPromise(promise, error);
        } else if (error.retries && error.retries > 1) {
          dispatch(handleException(error, reject, false));
        }
      });
    return promise();
  };
}
